module.exports = {
    handle: (e, products) => {
        if (!products) {
            return;
        }

        let impressions = [];
        try {
            impressions = JSON.parse(products) || [];
        } catch(e) {
            return;
        }

        const newImpressions = [];
        let customerId, emailAddress;

        impressions.forEach((element, index) => {
            if (index === 0) {
                customerId = element.customerId;
                emailAddress = element.emailAddress;
            }

            newImpressions.push({
                'item_name' : element.name,
                'item_id' : element.id,
                'price' : element.price,
                'item_brand' : element.brand,
                'item_category' : element.category,
                'quantity' : 1
            });
        });

        const viewItemList = {
            event: 'view_item_list',
            ecommerce: {
                items: newImpressions
            }
        };

        customerId ? viewItemList.userId = customerId : null;
        emailAddress ? viewItemList.email = emailAddress : null;

        dataLayer.push(viewItemList);
    }
}